import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, input, viewChild } from '@angular/core';
import { RouterModule } from '@angular/router';

import { IconModule } from 'ish-core/icon.module';
import { ContentPageletView } from 'ish-core/models/content-view/content-view.model';

@Component({
  selector: 'custom-cms-main-navigation-link',
  templateUrl: './cms-main-navigation-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, IconModule],
})
export class CmsMainNavigationLinkComponent implements AfterViewInit {
  readonly pagelet = input<ContentPageletView>(undefined);
  readonly subNav = viewChild<ElementRef>('subNav');

  subNavCount = Array.from({ length: 12 }, (_, index) => index + 1);
  plusIcon = true;
  isSubNavPresent = false;

  ngAfterViewInit() {
    const subNav = this.subNav();
    if (subNav !== undefined) {
      const ulElement = subNav.nativeElement;
      const liElements = ulElement.querySelectorAll('li');
      if (liElements.length > 0) {
        this.isSubNavPresent = true;
      }
    }
  }

  /**
   * Handle sub menu show.
   * Adds hover class to rendered element.
   *
   * @param subMenu The rendered sub menu element.
   */
  subMenuShow(subMenu: HTMLElement) {
    subMenu.classList.add('hover');
  }

  /**
   * Handle sub menu hide.
   * Removes hover class from rendered element.
   *
   * @param subMenu The rendered sub menu element.
   */
  subMenuHide(subMenu: HTMLElement) {
    subMenu.classList.remove('hover');
  }

  openToggle(): boolean {
    this.plusIcon = !this.plusIcon;
    return this.plusIcon;
  }
}
